import { Injectable } from '@angular/core';
import { BillingPaymentModel } from './billing-payment/billing-payment.model';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { BusinessUnitCompanyInformationModel } from './billing-company-information/business-unit-company-information.model';
import { CentralBillingUnitModuleModel } from './billing-central/central-billing-unit-module.model';
import { BillingUnitModuleModel } from './billing-unit/billing-unit-module.model';
import { CurrencyTypes, ICurrencyType } from '../customer-billing/customer-billing-price/currency-type';
import { AppTextService } from '@fi-shared/app-text';
import { BusinessUnitInvoiceInformationModel } from './billing-payment/business-unit-invoice-information.model';
import { BusinessUnitCreditCardInformationModel } from './billing-payment/business-unit-credit-card-information.model';

@Injectable()
export class BillingService {
    constructor(
        private fiBackend: FiBackendService,
        private appTextService: AppTextService,
    ) {}

    GetCentralBillingModules() {
        return this.fiBackend.fetchObjects('Billing/Billing/GetCentralBillingModules', CentralBillingUnitModuleModel);
    }

    GetCentralBillingModule(moduleType) {
        return this.fiBackend.fetchObject(
            'Billing/Billing/GetCentralBillingModule/{0}'.format(moduleType),
            CentralBillingUnitModuleModel,
        );
    }

    SaveCentralBillingModule(centralBillingUnitModule: CentralBillingUnitModuleModel) {
        return this.fiBackend.fetchDataPost('Billing/Billing/SaveCentralBillingModule', centralBillingUnitModule);
    }

    GetUnitBillingModules(unitId) {
        return this.fiBackend.fetchObjects(
            'Billing/Billing/GetUnitBillingModules/{0}'.format(unitId),
            BillingUnitModuleModel,
        );
    }

    GetUnitBillingModule(moduleType, unitId) {
        return this.fiBackend.fetchObject(
            'Billing/Billing/GetUnitBillingModule/{0}/{1}'.format(moduleType, unitId),
            BillingUnitModuleModel,
        );
    }

    SaveUnitBillingModule(billingUnitModule: BillingUnitModuleModel) {
        return this.fiBackend.fetchDataPost('Billing/Billing/SaveUnitBillingModule', billingUnitModule);
    }

    GetBusinessUnitCompanies() {
        return this.fiBackend.fetchObjects(
            'Billing/Billing/GetBusinessUnitCompanies',
            BusinessUnitCompanyInformationModel,
        );
    }

    GetBusinessUnitCompanyInformation(unitId) {
        return this.fiBackend.fetchObject(
            'Billing/Billing/GetBusinessUnitCompanyInformation/{0}'.format(unitId),
            BusinessUnitCompanyInformationModel,
        );
    }

    SaveBusinessUnitCompanyInformation(businessUnitCompanyInformation: BusinessUnitCompanyInformationModel) {
        return this.fiBackend.fetchDataPost(
            'Billing/Billing/SaveBusinessUnitCompanyInformation',
            businessUnitCompanyInformation,
        );
    }

    GetCentralBillingPaymentInfo() {
        return this.fiBackend.fetchObject(
            'Billing/Billing/GetCentralBillingPaymentInfo',
            BusinessUnitInvoiceInformationModel,
        );
    }

    GetCreditCardInformation(unitId) {
        return this.fiBackend.fetchObject(
            'Billing/Billing/GetCreditCardInformation/{0}'.format(unitId),
            BusinessUnitCreditCardInformationModel,
        );
    }

    GetPaymentInformation() {
        return this.fiBackend.fetchObjects('Billing/Billing/GetPaymentInformation', BillingPaymentModel);
    }

    SaveBusinessUnitPaymentInformation(paymentInformation: any) {
        return this.fiBackend.fetchDataPost('Billing/Billing/SaveBusinessUnitPaymentInformation', paymentInformation);
    }

    GetBillingCurrencies() {
        return CurrencyTypes.map((currency: ICurrencyType) => {
            return {
                Id: currency.Id,
                Name: this.appTextService.get(currency.TextId),
            };
        });
    }
}
